import React from "react";
import { StyledFooter } from "./Footer.styles";

export const Footer = () => {
  return <StyledFooter />;
};
